// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { getHdRelayPosterSrc, getHdRelaySrc, isBuildTime } from '@powdr/utils';

import { WebcamGuid, WebcamIframe, WebcamPreview } from './components';
import { useWebcamPlayerMount } from './hooks';
import { WebcamFrame } from './styles';

export const Webcam = ({
  id,
  webcamGuid = null,
  relationships = null,
  disabled = false,
  fallbackImage = null,
  fallbackImageSrc = null,
  fallbackImageAlt = '',
}) => {
  const frameRef = useRef(null);
  const hdRelaySrc = getHdRelaySrc(relationships);
  const hdRelayTitle = relationships?.hdRelayCam?.name || 'Webcam';
  const hdRelayPosterSrc = getHdRelayPosterSrc(hdRelaySrc);
  const useGuidPlayer = Boolean(webcamGuid);
  const canPlay = !disabled && (useGuidPlayer || Boolean(hdRelaySrc));
  const { shouldMountPlayer, playerKey } = useWebcamPlayerMount({
    enabled: canPlay,
    frameRef,
  });
  const holderId = `${disabled ? `webcam_holder_${id}_thumb` : `webcam_holder_${id}`}_${playerKey}`;

  if (isBuildTime() || (!useGuidPlayer && !hdRelaySrc)) return null;

  return (
    <WebcamFrame ref={frameRef} className="webcam-frame" $disabled={disabled}>
      <div className="webcam-holder">
        {shouldMountPlayer && useGuidPlayer && (
          <WebcamGuid
            key={`webcam-guid-${playerKey}`}
            webcamGuid={webcamGuid}
            holderId={holderId}
          />
        )}
        {shouldMountPlayer && !useGuidPlayer && hdRelaySrc && (
          <WebcamIframe
            key={`webcam-iframe-${playerKey}`}
            src={hdRelaySrc}
            title={hdRelayTitle}
            disabled={disabled}
          />
        )}
        {!shouldMountPlayer && (
          <WebcamPreview
            title={hdRelayTitle}
            hdRelayPosterSrc={hdRelayPosterSrc}
            fallbackImage={fallbackImage}
            fallbackImageSrc={fallbackImageSrc}
            fallbackImageAlt={fallbackImageAlt}
          />
        )}
      </div>
    </WebcamFrame>
  );
};

Webcam.propTypes = {
  id: PropTypes.string.isRequired,
  webcamGuid: PropTypes.string,
  disabled: PropTypes.bool,
  fallbackImage: PropTypes.shape({}),
  fallbackImageSrc: PropTypes.string,
  fallbackImageAlt: PropTypes.string,
  relationships: PropTypes.shape({
    hdRelayCam: PropTypes.shape({
      name: PropTypes.string,
      hdRelayLink: PropTypes.shape({
        uri: PropTypes.string,
      }),
    }),
  }),
};
